// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles.css */
body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    background-color: #121212;
    color: #ffffff;
}

#app-container {
    padding: 2rem;
}

#app-container.game-detail-view {
    min-height: 100vh;
    min-height: 100dvh;
    padding: clamp(0.75rem, 2vw, 1.5rem);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Game List Styles */
.game-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 8rem;
    text-align: center;
}

.game-item a {
    text-decoration: none;
    color: inherit;
}

.game-item-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #333;
    border-radius: 12px;
    transition: transform 0.2s ease-out;
}

.game-item a:hover .game-item-image {
    transform: scale(1.05);
}

.game-item-title {
    margin-top: 1rem;
    font-size: 1.25rem;
    font-weight: bold;
}

.game-item-description {
    font-size: 0.9rem;
    color: #aaa;
    margin-top: 0.5rem;
}

/* Game Detail Styles */
.game-detail-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding: 2rem 2rem 0;
}

.back-button {
    padding: 10px 20px;
    font-size: 1rem;
    font-weight: bold;
    color: white;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50px;
    cursor: pointer;
    transition: background-color 0.2s ease;
    text-decoration: none;
}

.back-button:hover {
    background: rgba(255, 255, 255, 0.2);
}

.game-detail-title {
    font-size: 2.5rem;
    font-weight: bold;
}

.game-play-layout {
    width: min(100%, 1600px);
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: clamp(0.75rem, 2vw, 1.25rem);
    align-items: stretch;
}

#app-container.game-detail-view.leaderboard-active {
    align-items: flex-start;
}

#app-container.game-detail-view.leaderboard-active .game-play-layout {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 360px);
    align-items: start;
}

#leaderboard-slot {
    display: none;
    min-width: 0;
}

#app-container.game-detail-view.leaderboard-active #leaderboard-slot {
    display: block;
}

#game-container {
    position: relative;
    width: 100%;
    height: min(76vh, 56.25vw);
    min-height: 480px;
    border-radius: 12px;
    overflow: hidden;
    background: #000;
    margin: 0 auto;
    touch-action: none;
    -webkit-user-select: none;
    user-select: none;
}

#app-container.game-detail-view.leaderboard-active #game-container {
    height: min(76vh, calc((100vw - 420px) * 0.5625));
    min-height: 0;
}

@media (orientation: portrait), (max-width: 900px) {
    #app-container.game-detail-view {
        align-items: flex-start;
        overflow-y: auto;
    }

    #app-container.game-detail-view.leaderboard-active .game-play-layout {
        grid-template-columns: minmax(0, 1fr);
    }

    #game-container,
    #app-container.game-detail-view.leaderboard-active #game-container {
        height: min(68vh, 72vw);
        min-height: 320px;
        max-width: 100%;
    }
}

#ui-2d {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    pointer-events: none;
}

.ui-element {
    pointer-events: auto;
    padding: 15px 30px;
    font-size: 1.5rem;
    font-weight: bold;
    color: white;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 50px;
    cursor: pointer;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    transition: all 0.2s ease;
}

.ui-element:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
}


#score-2d {
    position: absolute;
    top: 20px;
    left: 30px;
    font-size: 2rem;
    font-weight: bold;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
    display: none;
}
#timer-2d {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 2rem;
    font-weight: bold;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
    display: none;
}

#combo-2d {
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 2rem;
    font-weight: bold;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);
    display: none;
}

#sound-controls-2d {
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    pointer-events: auto;
}

.sound-btn {
    width: 50px;
    height: 50px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sound-btn img {
    width: 60%;
    height: 60%;
}

@media (max-width: 768px) {
    #score-2d,
    #timer-2d,
    #combo-2d {
        font-size: 1rem; /* Smaller font size for mobile */
        top: 10px; /* Adjust spacing for smaller screens */
    }

    #score-2d {
        left: 15px;
    }

    #combo-2d {
        right: 15px;
    }
}

/* ===== Player Name Prompt ===== */
.player-name-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    backdrop-filter: blur(8px);
}

.player-name-dialog {
    text-align: center;
    padding: 2.5rem;
}

.player-name-dialog h2 {
    font-size: 2rem;
    margin: 0 0 0.5rem;
}

.player-name-dialog p {
    color: #888;
    margin: 0 0 1.5rem;
    font-size: 0.9rem;
}

.player-name-input {
    display: block;
    width: 260px;
    margin: 0 auto 1.5rem;
    padding: 12px 16px;
    font-size: 1.2rem;
    text-align: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    color: #fff;
    outline: none;
}

.player-name-input:focus {
    border-color: rgba(255, 255, 255, 0.6);
}

.player-name-submit {
    font-size: 1.1rem !important;
    padding: 12px 36px !important;
}

/* ===== Leaderboard Dock ===== */
.leaderboard-overlay {
    position: static;
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: auto;
}

.leaderboard-overlay.leaderboard-visible {
    opacity: 1;
}

.leaderboard-panel {
    width: 320px;
    max-height: 76vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
}

.leaderboard-header {
    text-align: center;
}

.leaderboard-score-display {
    display: flex;
    align-items: baseline;
    gap: 0.75rem;
    justify-content: center;
}

.leaderboard-your-score {
    font-size: 4rem;
    font-weight: 900;
    line-height: 1;
}

.leaderboard-rank {
    font-size: 1.4rem;
    color: #aaa;
    font-weight: 600;
}

.leaderboard-rank-top {
    color: #ffd700;
}

.leaderboard-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: auto;
}

.leaderboard-row {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    font-size: 0.95rem;
}

.leaderboard-row-you {
    background: rgba(255, 255, 255, 0.15);
}

.leaderboard-position {
    width: 2.5rem;
    flex-shrink: 0;
}

.leaderboard-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.leaderboard-row-score {
    font-weight: 700;
    margin-left: 1rem;
}

.leaderboard-empty {
    text-align: center;
    color: #666;
    padding: 1rem;
}

@media (orientation: portrait), (max-width: 900px) {
    .leaderboard-panel {
        width: 100%;
        max-height: none;
    }

    .leaderboard-list {
        max-height: 42vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,SAAS;IACT,gGAAgG;IAChG,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,qCAAqC;IACrC,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0DAA0D;IAC1D,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,iDAAiD;IACjD,aAAa;AACjB;;AAEA;IACI;QACI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;;QAEI,uBAAuB;QACvB,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,2BAA2B;IAC3B,mCAAmC;IACnC,yCAAyC;IACzC,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,sBAAsB;AAC1B;;;AAGA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,2CAA2C;IAC3C,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI;;;QAGI,eAAe,EAAE,iCAAiC;QAClD,SAAS,EAAE,uCAAuC;IACtD;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mCAAmC;AACnC;IACI,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,oCAAoC;IACpC,0CAA0C;IAC1C,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["/* src/styles.css */\nbody {\n    margin: 0;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n    background-color: #121212;\n    color: #ffffff;\n}\n\n#app-container {\n    padding: 2rem;\n}\n\n#app-container.game-detail-view {\n    min-height: 100vh;\n    min-height: 100dvh;\n    padding: clamp(0.75rem, 2vw, 1.5rem);\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Game List Styles */\n.game-list {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 8rem;\n    text-align: center;\n}\n\n.game-item a {\n    text-decoration: none;\n    color: inherit;\n}\n\n.game-item-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    background-color: #333;\n    border-radius: 12px;\n    transition: transform 0.2s ease-out;\n}\n\n.game-item a:hover .game-item-image {\n    transform: scale(1.05);\n}\n\n.game-item-title {\n    margin-top: 1rem;\n    font-size: 1.25rem;\n    font-weight: bold;\n}\n\n.game-item-description {\n    font-size: 0.9rem;\n    color: #aaa;\n    margin-top: 0.5rem;\n}\n\n/* Game Detail Styles */\n.game-detail-header {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n    padding: 2rem 2rem 0;\n}\n\n.back-button {\n    padding: 10px 20px;\n    font-size: 1rem;\n    font-weight: bold;\n    color: white;\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 50px;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    text-decoration: none;\n}\n\n.back-button:hover {\n    background: rgba(255, 255, 255, 0.2);\n}\n\n.game-detail-title {\n    font-size: 2.5rem;\n    font-weight: bold;\n}\n\n.game-play-layout {\n    width: min(100%, 1600px);\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    gap: clamp(0.75rem, 2vw, 1.25rem);\n    align-items: stretch;\n}\n\n#app-container.game-detail-view.leaderboard-active {\n    align-items: flex-start;\n}\n\n#app-container.game-detail-view.leaderboard-active .game-play-layout {\n    grid-template-columns: minmax(0, 1fr) minmax(280px, 360px);\n    align-items: start;\n}\n\n#leaderboard-slot {\n    display: none;\n    min-width: 0;\n}\n\n#app-container.game-detail-view.leaderboard-active #leaderboard-slot {\n    display: block;\n}\n\n#game-container {\n    position: relative;\n    width: 100%;\n    height: min(76vh, 56.25vw);\n    min-height: 480px;\n    border-radius: 12px;\n    overflow: hidden;\n    background: #000;\n    margin: 0 auto;\n    touch-action: none;\n    -webkit-user-select: none;\n    user-select: none;\n}\n\n#app-container.game-detail-view.leaderboard-active #game-container {\n    height: min(76vh, calc((100vw - 420px) * 0.5625));\n    min-height: 0;\n}\n\n@media (orientation: portrait), (max-width: 900px) {\n    #app-container.game-detail-view {\n        align-items: flex-start;\n        overflow-y: auto;\n    }\n\n    #app-container.game-detail-view.leaderboard-active .game-play-layout {\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    #game-container,\n    #app-container.game-detail-view.leaderboard-active #game-container {\n        height: min(68vh, 72vw);\n        min-height: 320px;\n        max-width: 100%;\n    }\n}\n\n#ui-2d {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    pointer-events: none;\n}\n\n.ui-element {\n    pointer-events: auto;\n    padding: 15px 30px;\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: white;\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    transition: all 0.2s ease;\n}\n\n.ui-element:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: scale(1.05);\n}\n\n\n#score-2d {\n    position: absolute;\n    top: 20px;\n    left: 30px;\n    font-size: 2rem;\n    font-weight: bold;\n    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);\n    display: none;\n}\n#timer-2d {\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 2rem;\n    font-weight: bold;\n    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);\n    display: none;\n}\n\n#combo-2d {\n    position: absolute;\n    top: 20px;\n    right: 30px;\n    font-size: 2rem;\n    font-weight: bold;\n    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.7);\n    display: none;\n}\n\n#sound-controls-2d {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    pointer-events: auto;\n}\n\n.sound-btn {\n    width: 50px;\n    height: 50px;\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sound-btn img {\n    width: 60%;\n    height: 60%;\n}\n\n@media (max-width: 768px) {\n    #score-2d,\n    #timer-2d,\n    #combo-2d {\n        font-size: 1rem; /* Smaller font size for mobile */\n        top: 10px; /* Adjust spacing for smaller screens */\n    }\n\n    #score-2d {\n        left: 15px;\n    }\n\n    #combo-2d {\n        right: 15px;\n    }\n}\n\n/* ===== Player Name Prompt ===== */\n.player-name-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.85);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 10000;\n    backdrop-filter: blur(8px);\n}\n\n.player-name-dialog {\n    text-align: center;\n    padding: 2.5rem;\n}\n\n.player-name-dialog h2 {\n    font-size: 2rem;\n    margin: 0 0 0.5rem;\n}\n\n.player-name-dialog p {\n    color: #888;\n    margin: 0 0 1.5rem;\n    font-size: 0.9rem;\n}\n\n.player-name-input {\n    display: block;\n    width: 260px;\n    margin: 0 auto 1.5rem;\n    padding: 12px 16px;\n    font-size: 1.2rem;\n    text-align: center;\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 12px;\n    color: #fff;\n    outline: none;\n}\n\n.player-name-input:focus {\n    border-color: rgba(255, 255, 255, 0.6);\n}\n\n.player-name-submit {\n    font-size: 1.1rem !important;\n    padding: 12px 36px !important;\n}\n\n/* ===== Leaderboard Dock ===== */\n.leaderboard-overlay {\n    position: static;\n    background: transparent;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    z-index: 1000;\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    pointer-events: auto;\n}\n\n.leaderboard-overlay.leaderboard-visible {\n    opacity: 1;\n}\n\n.leaderboard-panel {\n    width: 320px;\n    max-height: 76vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n}\n\n.leaderboard-header {\n    text-align: center;\n}\n\n.leaderboard-score-display {\n    display: flex;\n    align-items: baseline;\n    gap: 0.75rem;\n    justify-content: center;\n}\n\n.leaderboard-your-score {\n    font-size: 4rem;\n    font-weight: 900;\n    line-height: 1;\n}\n\n.leaderboard-rank {\n    font-size: 1.4rem;\n    color: #aaa;\n    font-weight: 600;\n}\n\n.leaderboard-rank-top {\n    color: #ffd700;\n}\n\n.leaderboard-list {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    overflow: auto;\n}\n\n.leaderboard-row {\n    display: flex;\n    align-items: center;\n    padding: 8px 12px;\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 8px;\n    font-size: 0.95rem;\n}\n\n.leaderboard-row-you {\n    background: rgba(255, 255, 255, 0.15);\n}\n\n.leaderboard-position {\n    width: 2.5rem;\n    flex-shrink: 0;\n}\n\n.leaderboard-name {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.leaderboard-row-score {\n    font-weight: 700;\n    margin-left: 1rem;\n}\n\n.leaderboard-empty {\n    text-align: center;\n    color: #666;\n    padding: 1rem;\n}\n\n@media (orientation: portrait), (max-width: 900px) {\n    .leaderboard-panel {\n        width: 100%;\n        max-height: none;\n    }\n\n    .leaderboard-list {\n        max-height: 42vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
